import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/reusable_sections/Header";
export default function GlobalLegalAuthority() {
  const {
    lang
  } = useLanguage();
  const content = {
    en: {
      eyebrow: "§ 01 — A FLORIDA KNOW-HOW HUB",
      title: "Expert guidance for your Multi level needs.",
      badge: "Florida Supreme Court Certified Family Mediator",
      credentialLine1: "FLORIDA SUPREME COURT CERTIFIED FAMILY MEDIATOR",
      credentialLine2: "& FLORIDA BAR CERTIFIED FOREIGN LEGAL CONSULTANT (HAITI)",
      services: [{
        id: 1,
        name: "Family & Divorce Mediation"
      }, {
        id: 2,
        name: "Foreign Legal Consulting (Haitian Law)"
      }, {
        id: 3,
        name: "Immigration Document Preparation"
      }, {
        id: 4,
        name: "Tax Preparation Services"
      }, {
        id: 5,
        name: "Real Estate Services"
      }, {
        id: 6,
        name: "Certified Translation Services"
      }, {
        id: 7,
        name: "Remote Online Notary (RON)"
      }],
      paragraph: "Stegy Group LLC is a Florida-registered consortium and know-how hub spanning immigration, tax, real estate, publishing, family mediation, and international legal matters. Anchored by Maitre Quesner Stephen—a Certified Foreign Legal Consultant and Florida Supreme Court Certified Family Mediator with extensive knowledge across Civil Law, Criminology, Real Estate, and Tax Preparation—our team delivers multidisciplinary, cross-border expertise for all your legal and regulatory needs.",
      cta: "Book a Consultation",
      credentials: "View Our Credentials",
      verification: "verified: florida-registered entity — fcflc certified consultant on team"
    },
    fr: {
      eyebrow: "§ 01 — UN CENTRE D'EXPERTISE FLORIDIENNE",
      title: "Des conseils experts pour vos besoins multiniveaux",
      badge: "Médiateur familial certifié Cour suprême de Floride",
      credentialLine1: "MÉDIATEUR FAMILIAL CERTIFIÉ DE LA COUR SUPRÊME DE FLORIDE",
      credentialLine2: "& CONSULTANT JURIDIQUE ÉTRANGER CERTIFIÉ DU BARREAU DE FLORIDE (HAÏTI)",
      services: [{
        id: 1,
        name: "Médiation Familiale & de Divorce"
      }, {
        id: 2,
        name: "Conseil Juridique Étranger (Droit Haïtien)"
      }, {
        id: 3,
        name: "Préparation de Documents d'Immigration"
      }, {
        id: 4,
        name: "Services de Préparation Fiscale"
      }, {
        id: 5,
        name: "Services Immobiliers"
      }, {
        id: 6,
        name: "Services de Traduction Certifiée"
      }, {
        id: 7,
        name: "Notaire en Ligne à Distance (RON)"
      }],
      paragraph: "Stegy Group LLC est un consortium et centre d'expertise enregistré en Floride, couvrant l'immigration, la fiscalité, l'immobilier, l'édition, la médiation familiale et les affaires juridiques internationales. Dirigée par Maître Quesner Stephen — Consultant Juridique Étranger Certifié et Médiateur Familial Certifié par la Cour Suprême de Floride avec de vastes connaissances en Droit Civil, Criminologie, Immobilier et Préparation Fiscale — notre équipe offre une expertise multidisciplinaire et transfrontalière pour tous vos besoins juridiques et réglementaires.",
      cta: "Réserver une consultation",
      credentials: "Voir nos accréditations",
      verification: "vérifié : entité enregistrée en floride — consultant certifié fcflc dans l'équipe"
    },
    ht: {
      eyebrow: "§ 01 — YON SANT EXPERTISE FLORID",
      title: "Direktiv ekspè pou bezwen ou",
      badge: "Mediatè Fanmi Sètifye Wo Tribinal Florid",
      credentialLine1: "MEDYATÈ FANMI SÈTIFYE TRIBINAL SIPRÈM FLORID",
      credentialLine2: "& KONSILTAN LEGAL ETRANJE SÈTIFYE BAWO FLORID (AYITI)",
      services: [{
        id: 1,
        name: "Mediyasyon Fanmi ak Divòs"
      }, {
        id: 2,
        name: "Konsiltasyon Legal Etranje (Lwa Ayisyen)"
      }, {
        id: 3,
        name: "Preparasyon Dokiman Imigrasyon"
      }, {
        id: 4,
        name: "Sèvis Preparasyon Taks"
      }, {
        id: 5,
        name: "Sèvis Imobilye"
      }, {
        id: 6,
        name: "Sèvis Tradiksyon Sètifye"
      }, {
        id: 7,
        name: "Notè an Liy a Distans (RON)"
      }],
      paragraph: "Stegy Group LLC se yon konsòsyòm ak sant ekspètiz ki anrejistre nan Florid, ki kouvri imigrasyon, taks, zafè imobilye, piblikasyon, medyasyon fanmi ak zafè legal entènasyonal. Dirije pa Mèt Quesner Stephen — Konsiltan Legal Etranje Sètifye ak Medyatè Fanmi Sètifye pa Tribinal Siprèm Florid la ki gen gwo konesans nan Dwa Sivil, Kriminoloji, Imobilye, ak Preparasyon Taks — ekip nou an bay ekspètiz miltidisiplinè ak transfrontalyè pou tout bezwen legal ak regilasyon ou yo.",
      cta: "Rezève yon konsiltasyon",
      credentials: "Gade akreditasyon nou",
      verification: "verifye : antite anrejistre nan florid — konsiltan sètifye fcflc nan ekip la"
    }
  };
  const t = content[lang as "en" | "fr" | "ht"] || content.en;
  return <section data-section-id="1907" id="global-legal-authority" className="relative dark bg-background py-28 md:py-36 overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="md:col-span-7 order-2 md:order-1">
            <p className="font-mono text-[12px] font-medium uppercase mb-8" style={{
            letterSpacing: "0.16em",
            color: "var(--foreground)",
            lineHeight: 1
          }}>
              {t.eyebrow}
            </p>

            <h1 className="font-serif font-medium text-white mb-8 w-full !text-4xl !text-center" style={{
            fontSize: "clamp(1.15rem, 4.2vw, 3.75rem)",
            letterSpacing: "-0.022em",
            lineHeight: 1.05
          }}><span className="!text-3xl">Expert guidance for your Multi level needs.</span></h1>

            <div className="w-full mb-8 flex justify-center">
              <div className="w-full border border-primary/40 bg-primary/10 text-primary font-mono uppercase rounded-lg px-2.5 sm:px-3 md:px-2.5 lg:px-4 py-3 text-center tracking-[0.03em] sm:tracking-[0.04em] md:tracking-[0.015em] lg:tracking-[0.015em] xl:tracking-[0.03em] font-semibold text-[11px] sm:text-xs md:text-[11px] lg:text-[12px] xl:text-[13px] leading-snug text-balance">
                <span className="block">{t.credentialLine1}</span>
                <span className={`block mt-1 ${lang === "en" ? "xl:whitespace-nowrap" : ""}`}>{t.credentialLine2}</span>
              </div>
            </div>

            <ul className="space-y-3 mb-10">
              {t.services.map((service, i) => <li key={service.id} data-index={i} className="flex items-center gap-3 text-foreground/90 font-sans font-normal" style={{
              fontSize: "clamp(1rem, 1.3vw, 1.2rem)"
            }}>
                  <span className="size-1.5 bg-primary rounded-full shrink-0" />
                  <span>{service.name}</span>
                </li>)}
            </ul>

            <div className="flex items-center mt-10 mb-8" aria-hidden="true">
              <span className="block" style={{
              width: "200px",
              height: "1px",
              backgroundColor: "var(--border)"
            }} />
              <span className="block" style={{
              width: "6px",
              height: "6px",
              backgroundColor: "var(--primary)",
              borderRadius: "9999px",
              marginLeft: "0px"
            }} />
            </div>

            <p className="italic text-foreground/80 max-w-xl !font-sans !font-thin" style={{
            fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
            fontWeight: 400,
            lineHeight: 1.55
          }}>
              <span className="!font-default !font-normal !italic [text-shadow:0px_8px_16px_rgba(20,21,31,0.22),_0px_4px_8px_rgba(20,21,31,0.16)] !text-justify !capitalize">
                {t.paragraph}
              </span>
            </p>

            <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono uppercase rounded-lg px-7 py-3.5 h-auto text-[12px] font-medium transition-colors duration-200" style={{
              letterSpacing: "0.12em"
            }}>
                <Link href="https://calendar.app.google/Javq5FfWckJk7vEQ9" newTab>{t.cta}</Link>
              </Button>

              <Link to="#" className="inline-flex items-center gap-2 font-serif italic text-foreground hover:text-primary transition-colors duration-200 group" style={{
              fontSize: "1.0625rem"
            }}>
                <span className="border-b border-foreground group-hover:border-primary group-hover:border-b-2 transition-all duration-200 pb-0.5">
                  {t.credentials}
                </span>
                <ArrowRight className="size-4" strokeWidth={1.25} />
              </Link>
            </div>

            <p className="mt-10 font-serif italic text-foreground/80" style={{
            fontSize: "0.8125rem",
            lineHeight: 1.5
          }}>
              {t.verification}
            </p>
          </div>

          <div className="md:col-span-5 order-1 md:order-2 relative">
            <div className="relative">
              <span aria-hidden="true" className="absolute font-serif font-normal pointer-events-none select-none hidden md:block" style={{
              fontSize: "14rem",
              color: "var(--foreground)",
              opacity: 0.08,
              lineHeight: 1,
              bottom: "-3rem",
              right: "-2rem",
              zIndex: 0
            }}>
                01
              </span>

              <div className="relative" style={{
              zIndex: 1
            }}>
                <div className="relative overflow-hidden rounded-xl ring-1 ring-white/10 shadow-2xl shadow-black/40">
                  <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1486499/img/QS-2-photo.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1486499/img/QS-2-photo.jpg-wvc-sizes" alt="Professional legal consultation environment with documents and law references" loading="lazy" decoding="async" className="w-full h-full object-cover" src="https://stegygroupllc.com/wp-content/uploads/2026/10/Mediation-faceb-photo_official.png" />
                  <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-background via-background/30 to-transparent pointer-events-none" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}